import React from 'react';
import { Logo } from '../Logo';
export function Footer() {
  return <footer className="w-full bg-navy-deep px-4 pb-28 pt-12 sm:px-6 sm:pb-32" data-id="element-204" data-mp="207kr6mx5mqd0">
      <div className="mx-auto max-w-3xl text-center" data-id="element-205" data-mp="209nf91eqy9f3">
        <div className="flex justify-center" data-id="element-206" data-mp="2f53erly3ixiv">
          <Logo tone="dark" data-id="element-207" data-mp="2f2qwf7ofel5a" />
        </div>

        <p className="mt-6 text-[13px] font-semibold text-white/70" data-id="element-208" data-mp="2a5h0d96j7b8h">© 2026 · Dr. Karito</p>
        <p className="mt-1 text-[13px] text-white/50" data-id="element-209" data-mp="1mfmnwsq4joor">All rights reserved.</p>

        <p className="mx-auto mt-6 max-w-2xl text-[11.5px] leading-relaxed text-white/45" data-id="element-210" data-mp="1hh31ysbj6cwe">
          Educational material intended for healthcare professionals. It does not replace individual
          clinical judgment, current clinical guidelines, appropriate medical training, or
          applicable local regulations.
        </p>
      </div>
    </footer>;
}